import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import Stack from "@mui/material/Stack"
import { useSelector } from "react-redux"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import CircleIcon from "@mui/icons-material/Circle"
import dayjs, { Dayjs } from "dayjs"
import { ISelectedTimeSlot } from "./model/SelectedTimeSlot"
import { SubmitHandler, useForm } from "react-hook-form"
import {
  useDeleteTimeSlotsMutation,
  useGetSelectTimeSlotsQuery,
  useUpdateTimeSlotsMutation,
} from "../../../api/TimeSlotsApi"
import TextField from "@mui/material/TextField"
import MenuItem from "@mui/material/MenuItem"
import { DatePicker, TimePicker } from "@mui/x-date-pickers"
import DateRangeIcon from "@mui/icons-material/DateRange"
import WatchLaterIcon from "@mui/icons-material/WatchLater"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import { keycloakInstance } from "../../../../../shared/libs/keycloack/config"
import { RootState } from "@reduxjs/toolkit/dist/query/react"

const CRUDTimeSlotsDialog = ({ open, setOpen }: any) => {
  const timeSlot = useSelector((state: any) => state.selectedTimeSlot)

  const timeSlotDate = useSelector((state: any) => state.selectedTimeSlot?.date)

  const timeSlotfullName = useSelector(
    (state: any) => state.selectedTimeSlot.fullName,
  )

  const timeSlotuserId = useSelector(
    (state: any) => state.selectedTimeSlot.userId,
  )

  const { handleSubmit, register, watch, formState, clearErrors, setValue } =
    useForm<ISelectedTimeSlot>({
      defaultValues: {
        fullName: timeSlot.fullName,
        userId: timeSlot.userId,
        id: timeSlot.id,
        date: timeSlotDate,
        startDate: timeSlot.startDate,
        endDate: timeSlot.endDate,
        comment: timeSlot.comment,
        type: {
          id: timeSlot.type.id,
          name: timeSlot.type.name,
        },
      },
    })
  const [deleteTimeSlots] = useDeleteTimeSlotsMutation()
  const [updateTimeSlots] = useUpdateTimeSlotsMutation()

  const onSubmitDelete: SubmitHandler<ISelectedTimeSlot> = async (
    data: ISelectedTimeSlot,
  ) => {
    try {
      const response = await deleteTimeSlots(data)
      setOpen({ ...open, openCRUDTimeSlots: { open: false } })
      console.log(response)
    } catch (error) {
      console.error("Error deleting interview:", error)
    }
  }
  const onSubmitUpdate: SubmitHandler<ISelectedTimeSlot> = async (
    data: ISelectedTimeSlot,
  ) => {
    try {
      const response = await updateTimeSlots(data)
      setOpen({ ...open, openCRUDTimeSlots: { open: false } })
      console.log(response)
    } catch (error) {
      console.error("Error updating interview:", error)
    }
  }

  const timeSlotsSelects = useGetSelectTimeSlotsQuery()

  const { errors } = formState

  const isHiringAdmin = keycloakInstance.realmAccess?.roles.some((role) =>
    ["hiring-admin"].includes(role),
  )

  return (
    <Dialog
      sx={{
        ".MuiDialog-paper": {
          width: open.openCRUDTimeSlots.type === "delete" ? "413px" : "713px",
          px: "20px",
        },
        ".MuiDialogContent-root": {},
        ".MuiDialogActions-root": { px: "24px", pb: "40px" },
      }}
      maxWidth={"lg"}
      open={open.openCRUDTimeSlots.open}
      onClose={() => setOpen({ ...open, openCRUDTimeSlots: { open: false } })}
      keepMounted
      aria-describedby="alert-dialog-slide-description"
    >
      <form
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
        }}
        onSubmit={
          open.openCRUDTimeSlots.type === "edit"
            ? handleSubmit(onSubmitUpdate)
            : handleSubmit(onSubmitDelete)
        }
      >
        <DialogTitle sx={{ fontWeight: "bold", mt: "20px" }}>
          {open.openCRUDTimeSlots.type === "delete" &&
            timeSlot.isDeletable &&
            "Вы уверены, что хотите удалить данный слот?"}
          {open.openCRUDTimeSlots.type === "edit" && "Редактирование слота"}
          {!timeSlot.isDeletable &&
            open.openCRUDTimeSlots.type === "delete" &&
            (timeSlot?.usersPut.length > 1
              ? "На это собеседование уже назначены кандидаты"
              : "На это собеседование уже назначен кандидат")}
        </DialogTitle>
        <DialogContent>
          <Stack spacing={"30px"} justifyContent={"center"}>
            {open.openCRUDTimeSlots.type === "edit" && (
              <Stack direction={"row"} alignItems={"center"} spacing={"20px"}>
                <Typography fontSize={20}> {timeSlotfullName} </Typography>
                <Typography fontSize={14} color={"#8B8B8B"}>
                  ID: {timeSlotuserId}
                </Typography>
              </Stack>
            )}
            <Stack
              spacing={"10px"}
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              {open.openCRUDTimeSlots.type === "edit" && (
                <Stack
                  spacing={"5px"}
                  direction="column"
                  sx={{ width: "100%" }}
                >
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "700",
                      color: "rgba(23, 23, 23, 0.5)",
                    }}
                  >
                    {timeSlotDate &&
                      dayjs
                        .utc(timeSlot.date)
                        .format("dddd DD.MM.YYYY")
                        .replace(/^\p{L}/u, (match) => match.toUpperCase())}
                  </Typography>
                  <Box
                    sx={{
                      py: "10px",
                      paddingLeft: "20px",
                      paddingRight: "10px",
                      background:
                        "linear-gradient(90deg, rgba(3.19, 3.19, 3.19, 0.10) 0%, rgba(24.46, 25.50, 24.44, 0) 100%)",
                      borderRadius: "4px",
                      borderLeft: "1px rgba(23, 23, 23, 0.50) solid",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      display: "inline-flex",
                      height: "100px",
                      width: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        flex: "1 1 0",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        gap: "5px",
                        display: "inline-flex",
                      }}
                    >
                      <Typography
                        style={{
                          alignSelf: "stretch",
                          color: "rgba(23, 23, 23, 0.5)",
                          fontSize: 14,
                          fontWeight: "400",
                          wordWrap: "break-word",
                        }}
                      >
                        {dayjs.utc(timeSlot.startDate).format("HH:mm")} -{" "}
                        {dayjs.utc(timeSlot.endDate).format("HH:mm")}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "12px",
                          fontWeight: "400",
                          wordWrap: "break-word",
                          color: "rgba(23, 23, 23, 0.5)",
                        }}
                      >
                        {timeSlot.type.name}
                      </Typography>
                      <Stack
                        direction={"row"}
                        spacing={"5px"}
                        alignItems={"center"}
                        justifyContent={"flex-start"}
                      >
                        <CircleIcon
                          sx={{
                            height: "10px",
                            width: "10px",
                            color:
                              timeSlot?.usersCount < timeSlot?.limit &&
                              (timeSlot?.usersCount !== 0 ||
                                timeSlot?.usersCount === timeSlot?.limit)
                                ? "rgba(255, 124, 3, 1)"
                                : timeSlot?.usersCount === timeSlot?.limit
                                ? "rgba(251, 55, 55, 1)"
                                : timeSlot?.usersCount === 0
                                ? "rgba(27, 156, 24, 1)"
                                : null,
                          }}
                        />
                        <Typography
                          sx={{
                            fontSize: "12px",
                            fontWeight: "400",
                          }}
                        >
                          {timeSlot?.usersCount < timeSlot?.limit &&
                            (timeSlot?.usersCount !== 0 ||
                              timeSlot?.usersCount === timeSlot?.limit) &&
                            `${timeSlot?.usersCount}/${timeSlot?.limit}`}
                          {timeSlot?.usersCount === timeSlot?.limit && `Занято`}
                          {timeSlot?.usersCount === 0 && `Свободно`}
                        </Typography>
                      </Stack>
                    </Box>
                  </Box>
                </Stack>
              )}

              {open.openCRUDTimeSlots.type === "edit" && (
                <ArrowForwardIcon sx={{ color: "rgba(23, 23, 23, 0.5)" }} />
              )}

              <Stack spacing={"5px"} direction="column" sx={{ width: "100%" }}>
                <Typography sx={{ fontSize: "16px", fontWeight: "700" }}>
                  {timeSlotDate &&
                    dayjs
                      .utc(watch("date"))
                      .format("dddd DD.MM.YYYY")
                      .replace(/^\p{L}/u, (match) => match.toUpperCase())}
                </Typography>
                <Box
                  sx={{
                    py: "10px",
                    paddingLeft: "20px",
                    paddingRight: "10px",
                    background:
                      "linear-gradient(90deg, rgba(26.72, 156.19, 24.08, 0.10) 0%, rgba(26.72, 156.19, 24.08, 0) 100%)",
                    borderRadius: "4px",
                    borderLeft: "1px #1B9C18 solid",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    display: "inline-flex",
                    height: "100px",
                    width: "100%",
                  }}
                >
                  <Box
                    sx={{
                      flex: "1 1 0",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start",
                      gap: "5px",
                      display: "inline-flex",
                    }}
                  >
                    <Typography
                      style={{
                        alignSelf: "stretch",
                        color: "#171717",
                        fontSize: 14,
                        fontWeight: "400",
                        wordWrap: "break-word",
                      }}
                    >
                      {dayjs.utc(watch("startDate")).format("HH:mm")} -{" "}
                      {dayjs.utc(watch("endDate")).format("HH:mm")}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: "400",
                        wordWrap: "break-word",
                      }}
                    >
                      {watch("type.id") === 1 ? "Групповое" : "Индивидуальное"}
                    </Typography>
                    <Stack
                      direction={"row"}
                      spacing={"5px"}
                      alignItems={"center"}
                      justifyContent={"flex-start"}
                    >
                      <CircleIcon
                        sx={{
                          height: "10px",
                          width: "10px",
                          color:
                            timeSlot?.usersCount < timeSlot?.limit &&
                            (timeSlot?.usersCount !== 0 ||
                              timeSlot?.usersCount === timeSlot?.limit)
                              ? "rgba(255, 124, 3, 1)"
                              : timeSlot?.usersCount === timeSlot?.limit
                              ? " rgba(251, 55, 55, 1)"
                              : timeSlot?.usersCount === 0
                              ? "rgba(27, 156, 24, 1)"
                              : null,
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: "12px",
                          fontWeight: "400",
                        }}
                      >
                        {timeSlot?.usersCount < timeSlot?.limit &&
                          (timeSlot?.usersCount !== 0 ||
                            timeSlot?.usersCount === timeSlot?.limit) &&
                          `${timeSlot?.usersCount}/${timeSlot?.limit}`}
                        {timeSlot?.usersCount === timeSlot?.limit && `Занято`}
                        {timeSlot?.usersCount === 0 && `Свободно`}
                      </Typography>
                    </Stack>
                  </Box>
                </Box>
              </Stack>
            </Stack>
            {open.openCRUDTimeSlots.type !== "delete" && (
              <Stack spacing={"10px"}>
                <Stack direction={"column"} spacing={"5px"}>
                  <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                    Тип собеседования
                  </Typography>
                  <TextField
                    size="small"
                    label="Тип собеседования"
                    fullWidth
                    inputProps={register("type.id")}
                    value={watch("type.id")}
                    select
                    error={Boolean(formState.errors.type?.id?.message)}
                  >
                    {timeSlotsSelects.data?.interviwerType.map(
                      (option: any) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ),
                    )}
                  </TextField>
                </Stack>

                <Stack direction={"column"} spacing={"5px"}>
                  <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                    Дата
                  </Typography>
                  <DatePicker
                    sx={{
                      ".MuiIconButton-root": {
                        color: "rgba(139, 139, 139, 1)",
                      },
                    }}
                    slots={{
                      openPickerIcon: DateRangeIcon,
                    }}
                    value={dayjs.utc(watch("date")) || null}
                    localeText={{
                      toolbarTitle: "ЧЧ.ММ.ГГГГ",
                      fieldDayPlaceholder: () => "ДД",
                      fieldMonthPlaceholder: () => "ММ",
                      fieldYearPlaceholder: () => "ГГГГ",
                    }}
                    onChange={(e: Dayjs | null) => {
                      dayjs.utc(e).isValid() && clearErrors("date")
                      setValue("date", dayjs(e))
                    }}
                    format="DD.MM.YYYY"
                    slotProps={{
                      textField: {
                        inputProps: register("date"),
                        size: "small",
                        variant: "outlined",
                        placeholder: "ДД.ММ.ГГГГ",
                      },
                    }}
                  />
                </Stack>

                <Stack direction={"column"} spacing={"5px"}>
                  <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                    Время
                  </Typography>
                  <Stack
                    alignItems={"center"}
                    justifyContent={"center"}
                    direction={"row"}
                    spacing={"5px"}
                  >
                    <TimePicker
                      slots={{
                        openPickerIcon: WatchLaterIcon,
                      }}
                      sx={{
                        ".MuiIconButton-root": {
                          color: "rgba(139, 139, 139, 1)",
                        },
                      }}
                      value={dayjs.utc(watch("startDate")) || null}
                      localeText={{
                        toolbarTitle: "ЧЧ.ММ",
                        fieldHoursPlaceholder: () => "ЧЧ",
                        fieldMinutesPlaceholder: () => "ММ",
                      }}
                      onChange={(e: Dayjs | null) => {
                        dayjs.utc(e).isValid() && clearErrors("startDate")
                        setValue("startDate", dayjs(e))
                      }}
                      format="HH:mm"
                      slotProps={{
                        textField: {
                          inputProps: register("startDate", {
                            required: "Это поле обязательно для заполнения",
                          }),

                          size: "small",
                          variant: "outlined",
                          placeholder: "ЧЧ.ММ",
                          fullWidth: true,
                          error: Boolean(errors?.startDate),
                          helperText: errors?.startDate?.message,
                        },
                      }}
                    />
                    <div
                      style={{
                        width: "10px",
                        height: "1px",
                        background: "#CACACA",
                        borderRadius: 4,
                      }}
                    />
                    <TimePicker
                      slots={{
                        openPickerIcon: WatchLaterIcon,
                      }}
                      sx={{
                        ".MuiIconButton-root": {
                          color: "rgba(139, 139, 139, 1)",
                        },
                      }}
                      value={dayjs.utc(watch("endDate")) || null}
                      localeText={{
                        toolbarTitle: "ЧЧ.ММ",
                        fieldHoursPlaceholder: () => "ЧЧ",
                        fieldMinutesPlaceholder: () => "ММ",
                      }}
                      onChange={(e: Dayjs | null) => {
                        dayjs.utc(e).isValid() && clearErrors("endDate")
                        setValue("endDate", dayjs(e))
                      }}
                      format="HH:mm"
                      slotProps={{
                        textField: {
                          inputProps: register("endDate", {
                            required: "Это поле обязательно для заполнения",
                          }),

                          size: "small",
                          variant: "outlined",
                          placeholder: "ЧЧ.ММ",
                          fullWidth: true,
                          error: Boolean(errors?.endDate),
                          helperText: errors?.endDate?.message,
                        },
                      }}
                    />
                  </Stack>
                </Stack>

                <Stack direction={"column"} spacing={"5px"}>
                  <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
                    Комментарий
                  </Typography>
                  <Stack
                    alignItems={"center"}
                    justifyContent={"center"}
                    direction={"row"}
                    spacing={"5px"}
                  >
                    <TextField
                      size="small"
                      InputProps={{
                        inputProps: {
                          maxLength: 15,
                        },
                        ...register("comment"),
                      }}
                      fullWidth
                      value={watch("comment")}
                      placeholder="Комментарий"
                    />
                  </Stack>
                </Stack>
              </Stack>
            )}
            {!timeSlot.isDeletable &&
              open.openCRUDTimeSlots.type === "delete" && (
                <Stack spacing={"10px"}>
                  <Typography fontWeight={500} color={"error"}>
                    Сначала нужно перенести дату собеседования у кандидата/ов:
                  </Typography>

                  <Stack>
                    {timeSlot.usersPut.map((item: any, index: number) => (
                      <Stack
                        key={item.id}
                        direction={"column"}
                        spacing={"10px"}
                      >
                        <Stack direction={"column"}>
                          <Typography fontSize={16} fontWeight={500}>
                            {index + 1}.{item.name}
                          </Typography>
                          <Typography
                            color={"text.secondary"}
                            fontSize={14}
                            fontWeight={400}
                            sx={{ ml: "14px" }}
                          >
                            ID: {item.id}
                          </Typography>
                        </Stack>
                      </Stack>
                    ))}
                  </Stack>
                </Stack>
              )}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Stack
            justifyContent={"space-between"}
            sx={{ width: "100%" }}
            direction="row"
            spacing={"10px"}
          >
            <Button
              size="large"
              sx={{ fontWeight: "bold" }}
              fullWidth
              variant="outlined"
              onClick={() => setOpen({ ...open, openCRUDTimeSlots: false })}
            >
              Отмена
            </Button>
            {(timeSlot.isDeletable ||
              open.openCRUDTimeSlots.type !== "delete") && (
              <Button
                size="large"
                sx={{ fontWeight: "bold" }}
                fullWidth
                variant="contained"
                type="submit"
              >
                {open.openCRUDTimeSlots.type !== "delete"
                  ? "Сохранить"
                  : "Удалить"}
              </Button>
            )}
          </Stack>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default CRUDTimeSlotsDialog
